<div class="modal-header col-12">
    <h5 class="modal-title">Yeni Hatırlatma Oluştur</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body col-12">
    <form [formGroup]="reminderForm">
        <div class="row">
            <div class="col-xl-5 col-md-6 col-sm-12">
                <label for="kindId">Servis Türü</label>
                <div class="form-group">
                    <ng-select [items]="kinds" formControlName="kindId" placeholder="Servis Türü Seç" bindValue="id"
                        bindLabel="typeName"></ng-select>
                </div>
            </div>

            <div class="col-xl-5 col-md-6 col-sm-12">
                <label class="form-label">CC Mail (opsiyonel)</label>
                <input type="email" class="form-control" formControlName="ccMail">
            </div>

            <div class="col-xl-2 col-md-3 col-sm-12">
                <div class="form-check mt-1">
                    <input type="checkbox" class="form-check-input" id="isActive" formControlName="isActive">
                    <label class="form-check-label" for="isActive">Aktif</label>
                </div>
            </div>

            <div class="col-xl-12 col-md-6 col-sm-12">
                <label class="form-label">Konu Başlığı</label>
                <input type="text" class="form-control"
                    placeholder="Buraya yazılan mailde ilgili konu başlığı olarak gönderilir"
                    formControlName="serviceName" />
            </div>

            <div class="col-12">
                <label class="form-label">Mesaj (opsiyonel)</label>
                <textarea class="form-control" formControlName="message"></textarea>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer col-12">
    <button type="button" class="btn btn-secondary" (click)="onClose(false)">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="reminderForm.invalid" (click)="save()">Kaydet</button>
</div>